import { memo } from "react";
import { Button, Empty } from "antd";

import styles from "./index.less";

import { FlowNodeInputItemType } from "@packages/flow-core/module/node/types";
import { PlusOutlined } from "@ant-design/icons";

interface ChatPluginMockInputProps {
  inputs: FlowNodeInputItemType[];
  onAppendNewPluginInput: () => void;
  disabled: boolean;
}

export default memo(function ({
  inputs,
  onAppendNewPluginInput,
  disabled,
}: ChatPluginMockInputProps) {
  return (
    <>
      {inputs.length === 0 && (
        <Empty
          description="该子流程可能未进行正确配置"
          className={styles["inputs-empty"]}
        >
          <div>请检查该子流程是否进行了正确的输入参数设置！</div>
        </Empty>
      )}
      {inputs.length > 0 && (
        <div className={styles["inputs-container"]}>
          <Button
            type="primary"
            className={styles["app-new-plugin-btn"]}
            onClick={onAppendNewPluginInput}
            icon={<PlusOutlined />}
            disabled={disabled}
          >
            添加子流程输入参数
          </Button>
        </div>
      )}
    </>
  );
});
